import { Theme } from '@mui/material/styles';

export default function Progress(theme: Theme) {
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: 'hidden',
        },
        bar: {
          borderRadius: 4,
          height: 8,
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.lighter,
        },
        buffer: {
          backgroundColor: 'transparent',
        },
        determinate: {
          backgroundColor: theme.palette.grey[400],
        },
      },
    },
  };
}
